import { useEffect, useState } from 'react'

export const useGeolocation = (enabled: boolean): number[] => {
  const [position, setPosition] = useState<number[]>(null)
  useEffect(() => {
    if (enabled) {
      const opts = { enableHighAccuracy: true, maximumAge: 600000 }
      // eslint-disable-next-line no-undef
      const handleSuccess: PositionCallback = (pos) => setPosition([pos.coords.latitude, pos.coords.longitude])
      // eslint-disable-next-line no-undef
      const handleError: PositionErrorCallback = () => setPosition(null)
      const wid = navigator.geolocation.watchPosition(handleSuccess, handleError, opts)
      return () => {
        navigator.geolocation.clearWatch(wid)
        setPosition(null)
      }
    }
  }, [enabled])
  return position
}
